import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Button, Form, Space } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { useInvoiceFiltersStore } from 'shared/stores/use-invoices-filters.ts';
import { InvoicesFiltersDrawer } from './components/invoices-filters-drawer';
import { InvoicesSearch } from './components/invoices-search';

export const InvoicesFilter: React.FC = () => {
  const { t } = useTranslation();
  const { filters, search } = useInvoiceFiltersStore();
  const [isOpen, setIsOpen] = useState(false);
  const [form] = Form.useForm();

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <Space size='small'>
        <InvoicesSearch />
        <Badge dot={!!filters}>
          <Button type='primary' icon={<FilterOutlined />} disabled={!!search} ghost onClick={handleOpen}>
            {t('common:filters')}
          </Button>
        </Badge>
      </Space>
      <InvoicesFiltersDrawer form={form} isOpen={isOpen} onClose={handleClose} />
    </>
  );
};
